import { ChangeDetectionStrategy, Component } from '@angular/core';
import { first, orderBy } from 'lodash-es';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { FilterSearch, FilterSearchOption } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-search.model';
import { FilterSelectOption } from '@nimbus-library/features/shared/components/nimbus-grid-filter/domain/filter-select.model';
import { FilterSelectBase } from '@nimbus-library/features/shared/components/nimbus-grid-filter/nimbus-filter-select-base';

@Component({
  standalone: false,
  selector: 'nimbus-filter-search',
  templateUrl: './nimbus-filter-search.component.html',
  styleUrls: ['./nimbus-filter-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterSearchComponent extends FilterSelectBase<FilterSearch> {
  // Persisted filter state is just string[] ids, but we need the resolved
  // display name for the selected-chip label. Cache id->name from picks made
  // in this session so re-renders don't fall back to showing the raw id.
  private readonly displayNameById = new Map<string, string>();
  public selectedValues: FilterSearchOption[];

  public override onSelectionChanged(ev: FilterSelectOption[]): void {
    ev.forEach((o) => this.displayNameById.set(o.id, o.name));
    super.onSelectionChanged(ev);
  }

  protected getSummary(): string {
    if (!this.filterValue?.length) {
      return this.translateService.instant(TranslationKeys.FilterAll);
    }

    const labels = this.filterValue.map((v) => this.displayNameById.get(v) ?? v);
    const value = first(orderBy(labels, (c) => c.toLowerCase(), 'asc'));
    return this.filterValue.length === 1 ? value : `${value} +${this.filterValue.length - 1}`;
  }

  protected onFilterValueChanged(): void {
    this.selectedValues = this.filterValue?.map((v) => ({ id: v, name: this.displayNameById.get(v) ?? v })) || [];
  }
}
